module.exports = __webpack_public_path__ + "static/media/turf_mb.d1dbfa7a.jpg";